import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import api from './api'
// const jwtDecode = require('jwt-decode');

// setup Vue globals
Vue.prototype.$httpApi = api

// Only .env variables that start with VUE_APP_ will be statically embedded into the client bundle

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
